import React from 'react';
import { withRouter, RouteComponentProps, matchPath } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import protocolsService from '../../../services/protocols.service';
import fieldsService from '../../../services/fields.service';

import { IAutocompleteField, IField, IProtocol, IProtocolsRequest, IUor } from '../../../shared/interfaces';
import abilityBuild from '../../../shared/CASL/appAbility';
import { subject } from '@casl/ability';

import { Selection, DetailsList, DetailsListLayoutMode, IColumn, Icon, IDetailsHeaderProps, Text, IDetailsListStyles, IDetailsRowProps, IRenderFunction, Link, mergeStyleSets, Sticky, StickyPositionType, MessageBarType, MessageBar, SelectionMode, CheckboxVisibility, TooltipHost, DetailsHeader, ContextualMenu, IContextualMenuItem, ContextualMenuItemType, TooltipOverflowMode, ITooltipHostStyles, IDetailsColumnProps, IDetailsColumnStyles, IDetailsColumnFieldProps } from '@fluentui/react';
import { reduxActions, RootState } from '../../../store';

import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import { Protocol_State, Visibility_Type } from '../../../shared/enums';

import pdfImage from '../../../assets/images/pdf.svg'
import axios, { CancelTokenSource } from 'axios';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { myTheme } from '../../../assets/styles/my-theme';
import HoverCardContact from '../../DynamicForm/HoverCardContact';

const { palette } = myTheme;

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    tableIcons: {
        fontSize: '1.5em'

    },
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'


    },

    emptyColumn: {

    }
});

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};

const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        overflow: 'visible'
    }
}

const iconHeaderStyles: Partial<IDetailsColumnStyles> = {
    root: {
        width: '28px !important',
        padding: 0
    },
    cellTitle: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
    }

}

const acquiredPathString = "/:aooId/acquired";
const todayPathString = "/:aooId/today";
const draftsPathString = "/:aooId/drafts";

const queryString = require('query-string');

const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentUor: state.sessionReducer.currentUor,
    currentAoo: state.sessionReducer.currentAoo,
    isMobile: state.sessionReducer.isMobile
})
const mapDispatch = {
    setProtocol: (protocol: IProtocol) => (reduxActions.appNavigationActions.setProtocol(protocol)),
}


const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface ProtocolsTableState {
    columns: IColumn[];
    items: (IProtocol | null)[];
    protocolsRequest: IProtocolsRequest;
    isLoadingProtocols: boolean,
    messageBarIsVisible: boolean,
    messageBarType: MessageBarType | undefined,
    messageBarText: string
    selectedProtocol?: IProtocol
    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any

}
export interface ProtocolsTableProps {
    onSelectionChanged: (selectedProtocol?: IProtocol) => void;
    onDownloadAllButtonClick: () => void;
    forceTableRefresh?: boolean;
    deleteDraftHandler?: () => void;
    createProtocolFromHandler?: () => void;
}

type Props = ProtocolsTableProps & RouteComponentProps & PropsFromRedux

class ProtocolsTable extends React.Component<Props, ProtocolsTableState> {


    private protocolSelection: Selection;
    constructor(props) {
        super(props);

        this.protocolSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.protocolSelection.getSelection()[0] as IProtocol;
                this.setState({ selectedProtocol: selection });
                this.props.onSelectionChanged(selection);
            },
        });


        this.state = {
            items: [],
            columns: [],
            isLoadingProtocols: true,
            protocolsRequest: { filters: [] } as IProtocolsRequest,
            messageBarIsVisible: false,
            messageBarType: undefined,
            messageBarText: '',
            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined

        };
    }
    cancelTokenSources = {};


    componentDidMount() {
        this.setState({ isLoadingProtocols: true })

        /// currentAoo è già valorizzate al mount quando faccio routing da una 
        /// pagina qualsiasi verso una contenente ProtocolsTable
        if (this.checkUor() && this.props.currentAoo) {
            this.getFieldsAndProtocols()
        }

    }


    componentDidUpdate(oldProps: Props, oldState: ProtocolsTableState) {
        /// dopo il refresh pagina currentUor passa da undefined a valorizzato
        /// oppure se cambio uor
        if (this.checkUor() && oldProps.currentUor !== this.props.currentUor) {
            this.setState({
                isLoadingProtocols: true,
                items: [],
                protocolsRequest: { nextLink: undefined },
            });
            this.getFieldsAndProtocols()
        }
        if (oldProps.forceTableRefresh !== this.props.forceTableRefresh) {
            this.setState({
                items: []
            });
            this.protocolSelection.setItems([]);
            this.getFieldsAndProtocols();
        }
    }
    componentWillUnmount() {

        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }

    }

    dismissMessageBar = () => {
        this.setState({ messageBarIsVisible: false })
    }

    checkUor() {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (uorId) {
            return true;
        }
        else if (this.props.currentAoo) {

            this.props.history.push({ pathname: `/${this.props.currentAoo.id}/ricerca` });
            return false;

        }
        else {

            return false;

        }
    }


    getFieldsAndProtocols = () => {
        if (this.props.currentAoo && this.props.currentUor) {

            this.setState({ isLoadingProtocols: true })

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[fieldsService.getFieldsByViewName.name]?.cancel(fieldsService.getFieldsByViewName.name + " Request annullata");
            this.cancelTokenSources[protocolsService.getProtocolsAsStream.name]?.cancel(protocolsService.getProtocolsAsStream.name + " Request annullata");


            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[fieldsService.getFieldsByViewName.name] = axios.CancelToken.source();

            fieldsService
                .getFieldsByViewName(this.props.currentAoo.id, "Tutti i protocolli", this.cancelTokenSources[fieldsService.getFieldsByViewName.name].token)
                .then(fields => {
                    let _fields = fields.filter(f => !f.system && f.internalName !== 'Title' && f.internalName !== 'ID');

                    let newColumns: IColumn[] = [
                        {
                            key: 'visibilita',
                            name: 'visibilita',
                            fieldName: 'visibilita',
                            isIconOnly: true,
                            styles: iconHeaderStyles,
                            minWidth: 6,
                            maxWidth: 6,
                            onRenderField: this.onRenderVisibilitaField,
                            onRender: (item) => {

                                if (item.visibilita) {
                                    const arrayVisibilita = item.visibilita;
                                    const visibilitaObj = arrayVisibilita.find(obj => obj.uor.id === this.props.currentUor!.id);
                                    if (visibilitaObj.tipologia === Visibility_Type.Proprietario) {
                                        return < TooltipHost
                                            content="Proprietario"
                                            id={""}
                                        >
                                            <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'user-tie' }} style={{ fontSize: 16 }} />
                                        </TooltipHost>
                                    }
                                    if (visibilitaObj.tipologia === Visibility_Type.Inoltro) {
                                        return < TooltipHost
                                            content="Inoltro"
                                            id={""}
                                        >
                                            <Icon iconName="FastForward" style={{ fontSize: 16 }} />
                                        </TooltipHost>
                                    }
                                    if (visibilitaObj.tipologia === Visibility_Type.Visibilita) {
                                        return < TooltipHost
                                            content="Visibilità"
                                            id={""}
                                        >
                                            <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'eye' }} style={{ fontSize: 16 }} />
                                        </TooltipHost>
                                    }
                                    if (visibilitaObj.tipologia === Visibility_Type.CopiaConoscenza) {
                                        return < TooltipHost
                                            content="Copia Conoscenza"
                                            id={""}
                                        >
                                            <Icon iconName="Accounts" style={{ fontSize: 16 }} />
                                        </TooltipHost>
                                    }
                                }

                            }

                        },
                        {
                            key: 'attachment',
                            name: 'attachment',
                            fieldName: 'attachments',
                            isIconOnly: true,
                            styles: iconHeaderStyles,
                            minWidth: 7,
                            maxWidth: 7,
                            onRenderField: this.onRenderAttachmentField,
                            onRenderHeader: () => {
                                return <Icon iconName="Attach" className={classNames.fileIconHeaderIcon} />
                            },

                        }

                    ];

                    const { location } = this.props;
                    const matchTodayPath = matchPath(location.pathname, {
                        path: todayPathString,
                        exact: true
                    })
                    if (matchTodayPath) {
                        newColumns.push({
                            key: 'statoProtocolloIcon',
                            name: 'statoProtocolloIcon',
                            fieldName: 'StatoProtocollo',
                            isIconOnly: true,
                            styles: iconHeaderStyles,
                            minWidth: 9,
                            maxWidth: 9,
                            onRenderField: this.onRenderStatoProtocolloField,
                            onRenderHeader: () => {
                                return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} className={classNames.fileIconHeaderIcon} />
                            }

                        })
                    }

                    _fields.forEach(field => {
                        let col: IColumn = {
                            key: field.internalName,
                            fieldName: field.internalName,
                            name: field.displayName,
                            minWidth: 150,
                            isResizable: true,
                            ...field
                        };
                        if (field.internalName === 'Protocollo' || field.internalName === 'DataProtocollo' || field.internalName === 'StatoProtocollo') {
                            col.maxWidth = 110;
                            col.minWidth = 110;
                        } else if (field.internalName === "TipoProtocollo") {
                            col.maxWidth = 140;
                            col.minWidth = 140;
                        }
                        newColumns.push(col);
                    });
                    /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                    /// l'header e i contenuti della tabella 
                    if (!this.props.isMobile) {
                        newColumns.push(
                            {
                                key: 'empty',
                                name: 'empty',
                                fieldName: 'empty',
                                isIconOnly: true,

                                className: classNames.emptyColumn,
                                headerClassName: classNames.emptyColumn,
                                minWidth: 1,
                                maxWidth: 1,
                                onRender: (item) => {

                                },
                            },

                        );
                    }
                    this.setState({
                        columns: newColumns,
                    });
                    delete this.cancelTokenSources[fieldsService.getFieldsByViewName.name];





                    let filters: Partial<IField>[] = [];

                    // Uso matchPath per prendere i parametri dai path dei component figli

                    const matchAcquiredPath = matchPath(location.pathname, {
                        path: acquiredPathString,
                        exact: true
                    })
                    if (matchAcquiredPath) {

                        filters.push({
                            internalName: "StatoProtocollo",
                            internalValue: ["Allocato", "Acquisito"]
                        })

                    }

                    if (matchTodayPath) {

                        let today = new Date();
                        let dateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
                        filters.push({
                            internalName: "DataProtocollo",
                            internalValue: [dateOnly],
                        })


                    }
                    const matchWorkspacePath = matchPath(location.pathname, {
                        path: draftsPathString,
                        exact: true
                    })
                    if (matchWorkspacePath) {
                        filters.push({
                            internalName: "StatoProtocollo",
                            internalValue: ["In creazione", "In creazione da Mail"]
                        })



                    }

                    this.getProtocols({ nextLink: undefined, filters: filters });
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else {
                        this.setState({ isLoadingProtocols: false });
                        throw error;
                    }
                });

        }
    }
    onRenderVisibilitaField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.visibilita) {
            const arrayVisibilita = columnProps.item.visibilita;
            const visibilitaObj = arrayVisibilita.find(obj => obj.uor.id === this.props.currentUor!.id);
            switch (visibilitaObj.tipologia) {

                case Visibility_Type.Proprietario:
                    return (
                        <div className={classNames.iconField} >
                            <TooltipHost content="Proprietario" id={"tooltipProprietario"}>
                                <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'user-tie' }} style={{ fontSize: 16, color: palette.themePrimary }} />
                            </TooltipHost>
                        </div>
                    );

                case Visibility_Type.Inoltro:
                    return (
                        <div className={classNames.iconField} >
                            <TooltipHost content="Inoltro" id={"tooltipInoltro"}>
                                <Icon iconName="FastForward" style={{ fontSize: 16, color: palette.themePrimary }} />
                            </TooltipHost>
                        </div>
                    );

                case Visibility_Type.CopiaConoscenza:
                    return (
                        <div className={classNames.iconField} >
                            <TooltipHost content="Copia Conoscenza" id={"tooltipCopiaConoscenza"}>
                                <Icon iconName="Accounts" style={{ fontSize: 16, color: palette.themePrimary }} />
                            </TooltipHost>
                        </div>
                    );
                case Visibility_Type.Visibilita:
                    return (
                        <div className={classNames.iconField} >
                            <TooltipHost content="Visibilità" id={"tooltipVisibilita"}>
                                <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'eye' }} style={{ fontSize: 16, color: palette.themePrimary }} />
                            </TooltipHost>
                        </div>
                    );
                default:
                    return <div className={classNames.iconField} ></div>;

            }

        }
        return <div className={classNames.iconField} ></div>;
    }

    onRenderAttachmentField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.hasAttachments) {
            return (
                <div className={classNames.iconField} >
                    <TooltipHost content="Allegato">
                        <Icon iconName="Attach" style={{ fontSize: 16 }} />
                    </TooltipHost>
                </div>);
        }
        return <div className={classNames.iconField} ></div>;
    }

    onRenderStatoProtocolloField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.statoProtocollo === Protocol_State.Annullato) {
            return (
                <div className={classNames.iconField} >
                    <TooltipHost content="Annullato">
                        <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} style={{ fontSize: 16 }} />
                    </TooltipHost>
                </div>
            );

        }
        return <div className={classNames.iconField} ></div>;
    }

    onRenderDocumentField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.statoProtocollo !== Protocol_State.InCreazione && columnProps.item.statoProtocollo !== Protocol_State.InCreazioneDaMail) {
            return (
                <div className={classNames.iconField} >
                    <img src={pdfImage} className={classNames.fileIconImg} alt="Documento" />
                </div>);
        }
        return <div className={classNames.iconField} ></div>;
    }

    getProtocols = (protocolsRequest: IProtocolsRequest) => {



        protocolsRequest = { ...protocolsRequest, uor: this.props.currentUor }

        this.setState({ isLoadingProtocols: true, protocolsRequest: protocolsRequest })

        // se in cancelTokenSources c'è il cancelToken associato alla chiamata
        // chiamo il metodo cancel che interrompe la chiamata in pending
        this.cancelTokenSources[protocolsService.getProtocolsAsStream.name]?.cancel(protocolsService.getProtocolsAsStream.name + " Request annullata");
        // Ricreo il cancel token ad ogni request
        this.cancelTokenSources[protocolsService.getProtocolsAsStream.name] = axios.CancelToken.source();

        if (this.props.currentAoo && this.props.currentUor) {
            protocolsService.getProtocolsAsStream(this.props.currentAoo.id, protocolsRequest, this.cancelTokenSources[protocolsService.getProtocolsAsStream.name].token)
                .then(result => {
                    let currentItems = this.state.items.slice();

                    let itms: (IProtocol | null)[] = result.protocols;

                    if (result.nextLink) {
                        itms.push(null); //aggiungo un item null così DetailsList capisce che deve chiamare il metodo onRenderMissingItem
                    }

                    let { protocolsRequest } = this.state
                    protocolsRequest.nextLink = result.nextLink;
                    this.setState({
                        messageBarIsVisible: false,
                        items: [...currentItems, ...itms],
                        protocolsRequest: protocolsRequest,
                        isLoadingProtocols: false
                    });

                    delete this.cancelTokenSources[protocolsService.getProtocolsAsStream.name];
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }

                    this.setState({
                        isLoadingProtocols: false,
                        messageBarIsVisible: true,
                        messageBarType: MessageBarType.error,
                        messageBarText: "Errore imprevisto"

                    });
                    delete this.cancelTokenSources[protocolsService.getProtocolsAsStream.name];

                });

        }
    }

    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }
    onRenderMissingItem = (index?: number | undefined, rowProps?: IDetailsRowProps | undefined): null => {
        let currentItems = this.state.items.slice();
        currentItems.pop();
        this.setState({ items: currentItems }, () => { this.getProtocols(this.state.protocolsRequest) })

        return null;
    };

    onRenderItemColumn = (item?: IProtocol, index?: number | undefined, column?) => {
        let displayValue = "-";
        let columnContent: any | undefined;
        ({ displayValue, columnContent } = this.extractDisplayValueAndColumnContent(item, column));

        return (
            <TooltipHost
                content={displayValue}
                styles={tooltipHostStyles}
                overflowMode={TooltipOverflowMode.Self}
            >
                {columnContent}
            </TooltipHost>
        );
    }

    extractDisplayValueAndColumnContent = (item: IProtocol | undefined, column: any) => {
        let displayValue = "-";
        let columnInternalName = column?.fieldName;

        let columnContent: any = displayValue;

        if (item) {
            let protocol: IProtocol = { ...item };
            const fieldContent = protocol.fields?.find(it => it.internalName === columnInternalName);
            if (fieldContent) {
                const fieldColumnMerge: IField = { ...column, internalValue: fieldContent?.internalValue };
                displayValue = AppUtilities.getDisplayValueFromFieldControlType(fieldColumnMerge);
                if (columnInternalName === 'Protocollo') {
                    if (protocol.statoProtocollo === Protocol_State.InCreazione || protocol.statoProtocollo === Protocol_State.InCreazioneDaMail) {
                        displayValue = "Bozza";
                    }
                    columnContent = (
                        <Link onClick={(ev) => this.navigate(ev, item)}>{displayValue}</Link>
                    );
                }
                else {
                    switch (fieldColumnMerge.controlType) {
                        //case "autocompleteContact":
                        //    columnContent = (
                        //        <HoverCardContact field={fieldColumnMerge as IAutocompleteField} />
                        //    );
                        //    break;

                        case "calendar":
                        case "dropdown":
                        case "autocomplete":
                        case "autocompleteUser":
                        case "boolean":
                        case "textbox":
                        case "textarea":
                        default:
                            columnContent = displayValue;
                            break;


                    }

                }
            }
        }
        return { displayValue, columnContent };
    }
    //navigate = (ev, item?: IProtocol) => {
    //    ev?.preventDefault();
    //    ev?.stopPropagation();
    //    this.props.setProtocol(item!);
    //    //aggiunge gli zeri prima del numero
    //    const zeroPad = (num, places) => String(num).padStart(places, '0');
    //    let path;
    //    if (item && item.id && item.numeroProtocollo) {
    //        let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;

    //        path = `/${this.props.currentAoo!.id}/${item.id}/${protocolnumber}`;

    //    } else if (item && item.id) {

    //        path = `/${this.props.currentAoo!.id}/edit/${item.id}`;

    //    }
    //    this.props.history.push({ pathname: path, search: this.props.location.search });

    //}

    navigate = (ev, item?: IProtocol) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        if (item && item.id) {
            this.props.setProtocol(item!);
            //aggiunge gli zeri prima del numero
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;
            let path;
            switch (item.statoProtocollo) {
                case Protocol_State.Protocollato:
                case Protocol_State.Acquisito:
                case Protocol_State.Annullato:
                    path = `/${this.props.currentAoo!.id}/${item.id}/${protocolnumber}`;
                    break;
                case Protocol_State.Allocato:
                    path = `/${this.props.currentAoo!.id}/allocated/${item.id}/${protocolnumber}`;
                    break;
                case Protocol_State.InCreazione:
                case Protocol_State.InCreazioneDaMail:
                    path = `/${this.props.currentAoo!.id}/edit/${item.id}`;
                    break;

            }
            this.props.history.push({ pathname: path, search: this.props.location.search });
        }
    }

    // metodi gestione context menu 
    onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();

        const menuItems = this.updateContextMenuDashboard(ev, item);
        this.setState({ contextMenuItems: menuItems, showContextualMenu: true, contextMenuPosition: ev });
    };

    updateContextMenuDashboard = (ev, item) => {
        const menuItems: IContextualMenuItem[] = [];

        let prot: IProtocol = { visibilita: [{ tipologia: Visibility_Type.Proprietario, uor: { id: this.props.currentUor!.id } }] };
        const { location } = this.props;
        const matchDraftsPath = matchPath(location.pathname, {
            path: draftsPathString,
            exact: true
        });

        menuItems.push(
            {
                key: 'open',
                text: 'Apri documento',
                iconProps: { iconName: 'Document' },
                onClick: () => {
                    this.navigate(ev, item);
                    this.onHideContextualMenu();
                }

            }
        );

        if (item.hasAttachments) {
            menuItems.push(
                {
                    key: 'downloadAll',
                    text: 'Scarica tutto',
                    iconProps: { iconName: 'Download' },
                    onClick: () => {
                        this.props.onDownloadAllButtonClick();
                        this.onHideContextualMenu();
                    }
                }
            );
        }



        // ricavo le uor in cui l'utente corrente ha ruolo Operatore
        const userOperatoreUor = this.props.currentUser?.ruoliUorContext.reduce((a: IUor[], o) => (o.uor && o.uor.aooId === this.props.currentAoo?.id && o.ruolo && o.ruolo.nome === "Operatore" && a.push(o.uor), a), []) ?? [];

        // in questo caso non va bene utilizzare abilityBuild perchè verifica se l'utente può eseguire
        // l'azione solo nella uor corrente, mentre l'utente può scegliere in quale uor
        // creare il protocollo

        if (userOperatoreUor.length > 0) {
            menuItems.push(
                {
                    key: 'createFrom',
                    text: 'Crea da',
                    iconProps: { iconName: 'Copy' },
                    onClick: () => {
                        this.props.createProtocolFromHandler!();
                        this.onHideContextualMenu();
                    }
                }
            )
        }
        if (matchDraftsPath && abilityBuild.can('delete', subject('IProtocol', prot))
            && (this.state.selectedProtocol!.statoProtocollo === Protocol_State.InCreazione
                || this.state.selectedProtocol!.statoProtocollo === Protocol_State.InCreazioneDaMail)) {
            menuItems.push(
                {
                    key: 'deleteDraft',
                    text: 'Elimina bozza',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        this.props.deleteDraftHandler!();
                        this.onHideContextualMenu();
                    }
                }
            )
        }

        return menuItems;
    }

    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };

    public render() {
        return (

            <React.Fragment>
                <div className="protocols-table-component">
                    <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocols} />

                    {this.state.messageBarIsVisible &&
                        <MessageBar
                            messageBarType={this.state.messageBarType}
                            isMultiline={false}
                            onDismiss={this.dismissMessageBar}
                            dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                    }
                    {this.state.items.length > 0 &&
                        <DetailsList
                            className="with-empty-column"
                            styles={detailsListStyles}
                            items={this.state.items}
                            columns={this.state.columns}
                            onRenderItemColumn={this.onRenderItemColumn}
                            onRenderDetailsHeader={this.onRenderDetailsHeader}
                            onRenderMissingItem={this.onRenderMissingItem}
                            layoutMode={DetailsListLayoutMode.justified}
                            selection={this.protocolSelection}
                            selectionPreservedOnEmptyClick={true}
                            selectionMode={SelectionMode.single}
                            checkboxVisibility={CheckboxVisibility.onHover}
                            onItemContextMenu={this.onShowContextualMenu}

                        />
                    }
                    {this.state.items.length === 0 && !this.state.isLoadingProtocols &&

                        <Text block style={{ padding: 25 }}>Non ci sono protocolli.</Text>
                    }

                    <ContextualMenu
                        items={this.state.contextMenuItems!}
                        hidden={!this.state.showContextualMenu}
                        target={this.state.contextMenuPosition}
                        onItemClick={this.onHideContextualMenu}
                        onDismiss={this.onHideContextualMenu}
                    />
                </div>
            </React.Fragment>


        );
    }

}



export default connector(withRouter(ProtocolsTable));


